import { render, staticRenderFns } from "./room-participants-push.vue?vue&type=template&id=b58dd4e8"
import script from "./room-participants-push.vue?vue&type=script&lang=js"
export * from "./room-participants-push.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports